import { NOTIFICATION_KIND } from '@/constants'
import { FlashMessage, Toaster, Notification } from '@/types'

const notificationType = {
  0: 'promo',
  10: 'announcement',
  100: 'action',
}

export default class NotificationTransformer {
  static flashMessageToNotification(flashMessage: FlashMessage): Notification {
    return {
      kind: NOTIFICATION_KIND.FLASH,
      name: NOTIFICATION_KIND.FLASH,
      content: flashMessage.headerMessage.message,
      canUserDismiss: flashMessage.headerMessage.dismissible,
    }
  }

  static toasterToNotification(toaster: Toaster): Notification {
    return {
      kind: NOTIFICATION_KIND.TOASTER,
      name: toaster.name,
      content: toaster.content,
      canUserDismiss: true,
      type: notificationType[toaster.priority],
    }
  }
}
